function updateSliderLabel(slider) {
  const wrapper = slider.closest('.price-range-slider');
  const valueLabel = wrapper && wrapper.querySelector('[data-price-range-slider-value]');
  if (valueLabel) {
    valueLabel.textContent = slider.dataset.currencySymbol + slider.value;
  }
}

document.addEventListener('input', (event) => {
  const slider = event.target.closest('[data-price-range-slider]');
  if (!slider) return;
  updateSliderLabel(slider);
});

document.addEventListener('change', (event) => {
  const slider = event.target.closest('[data-price-range-slider]');
  if (!slider) return;
  updateSliderLabel(slider);

  const target = document.getElementById(slider.dataset.targetId);
  if (!target) return;
  target.value = slider.value;
  target.dispatchEvent(new Event('input', { bubbles: true }));
});
